import { render } from "./AddonEvents.vue?vue&type=template&id=68b8ecd7&scoped=true"
import script from "./AddonEvents.vue?vue&type=script&lang=js"
export * from "./AddonEvents.vue?vue&type=script&lang=js"

import "./AddonEvents.vue?vue&type=style&index=0&id=68b8ecd7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b8ecd7"]])

export default __exports__